export default "__VITE_ASSET__457b78ac__"